/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const NewChat: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M11.867 4.05165H6.08499C4.98042 4.05165 4.08499 4.94708 4.08499 6.05165V18.2143C4.08499 19.3189 4.98042 20.2143 6.08499 20.2143H17.649C18.7536 20.2143 19.649 19.3189 19.649 18.2143V11.2351M16.6559 4.05165C17.8248 2.88278 20.8179 5.87586 19.649 7.04474C19.0504 7.64335 12.4656 14.2281 12.4656 14.2281L8.87393 15.4254L9.47254 11.2351C9.47254 11.2351 16.0573 4.65027 16.6559 4.05165Z" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
